import React from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';

import styles from './VimeoEmbed.module.scss';

class VimeoEmbed extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      videoplay: false,
    }

    this.onChange = this.onChange.bind(this);
    this.onPlay = this.onPlay.bind(this);
  }

  onChange(isVisible) {
    const videoCurrentTime = this.video.currentTime;
    const videoDuration = this.video.duration;

    if (isVisible && videoCurrentTime !== videoDuration && this.props.autoplay) {
      this.video.play();
    }
    // switch (isVisible) {
    //   case true:
    //     this.video.play()
    //     break
    //
    //   case false:
    //     this.video.pause()
    //     this.video.currentTime = 0
    //     break
    // }
  }

  onPlay() {
    console.log('play')
  }

  render() {

    if (this.props.controls === true) {
      return(
        <div className={styles.VideoElement}>
          <video
            preload="metadata"
            src={this.props.url}
            poster={ this.props.poster ? this.props.poster.file.url : null }
            controls={true}
            loop={this.props.loop}
            playsInline
            ref={(video) => { this.video = video}}>
          </video>
        </div>
      )
    } else {
      return(
        <VisibilitySensor
          onChange={this.onChange}
          offset={this.props.offset || null}
          scrollCheck={false}
          partialVisibility={'bottom'}
          resizeCheck={true}>
            <video
              preload="metadata"
              src={this.props.url}
              poster={ this.props.poster ? this.props.poster.file.url : null }
              controls={false}
              loop={this.props.loop}
              playsInline
              ref={(video) => { this.video = video}}>
            </video>
        </VisibilitySensor>
      )
    }
  }
}

export default VimeoEmbed;



// WEBPACK FOOTER //
// ./src/components/Shared/VimeoEmbed/index.js